import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
/* ---------------- GET VALUATOR DETAIL ---------------- */
export const fetchValuatedBookletSummary = createAsyncThunk(
    "valuatedBookletSummary/fetchCount",
    async ( {
      valuatorCode,
      questionPaperCode,
      valuationTypeCode,
      valuationDate,
      examinationCode,
    }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/v1/Valuator/${valuatorCode}/${questionPaperCode}/${valuationTypeCode}/${valuationDate}/${examinationCode}/dailybookletscount-byvaluationtype`);

            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    },
);
const initialState = {
    data: {},
    loading: false,
    error: null,
};
const ValuatedBookletSummary = createSlice({
    name: "valuatedBookletSummary",
    initialState,
    reducers: {
        clearValuatedBookletSummary: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchValuatedBookletSummary.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchValuatedBookletSummary.fulfilled, (state, action) => {
                state.loading = false;
                const {
                    questionPaperCode,
                    valuationTypeCode,
                    examinationCode,
                } = action.meta.arg;
                const summaryKey = [
                    questionPaperCode,
                    valuationTypeCode,
                    examinationCode,
                ].join("::");

                state.data[summaryKey] = action.payload;
            })
            .addCase(fetchValuatedBookletSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearValuatedBookletSummary } = ValuatedBookletSummary.actions;
export default ValuatedBookletSummary.reducer;
